import { colors, styled } from 'assets/theme';
import React, { useEffect, useState } from 'react';
import { IChartIQData } from '../Quotefeed';

const CIQ = (window as any).CIQ;

interface ILegendProps {
	ciq?: any,
	symbol: string,
	chartTop?: number,
}

export const Legend: React.FunctionComponent<ILegendProps> = ({ ciq, symbol, chartTop }) => {
	const [legendData, setLegendData] = useState<IChartIQData | any>({});
	const [legendDate, setLegendDate] = useState('');

	useEffect(() => {
		if (ciq) {
			ciq.prepend('headsUpHR', () => {
				const tick = ciq.barFromPixel(ciq.cx);
				const prices = ciq.chart.xaxis[tick];
				if (tick) {
					if (prices && prices.data && prices.data) {
						setLegendData(prices.data);
					}
				}
				let date = '';
				if (prices && prices.data && !ciq.chart.xAxis.noDraw) {
					let tickDate = prices.data.displayDate;
					if (!tickDate) { tickDate = prices.data.DT};

					if (ciq.chart.xAxis.formatter) {
						// nothing to do
					} else if (ciq.internationalizer) {
						let str = ciq.internationalizer.monthDay.format(tickDate);
						if (!CIQ.ChartEngine.isDailyInterval(ciq.layout.interval) || tickDate) {
							str += ' ' + ciq.internationalizer.hourMinute.format(tickDate);
						} else {
							str = ciq.internationalizer.yearMonthDay.format(tickDate);
						}
						date = str;
					} else if (CIQ.ChartEngine.isDailyInterval(ciq.layout.interval) || tickDate.getYear() !== new Date().getFullYear()) {
						date = CIQ.mmddyyyy(CIQ.yyyymmddhhmm(tickDate));
					} else {
						date = CIQ.mmddhhmm(CIQ.yyyymmddhhmm(tickDate));
					}
				}
				setLegendDate(date);
			});
		}
	}, [ciq]);

	if (!ciq) { return <span />; }

	return (
		// <cq-hu-static>
		<LegendWrapper>
			<LegendContainer>
				<HeadsUpDisplay>
					<HeadsUpOlhc>
						<HeadsUpDataContainer label="Date">{legendDate}</HeadsUpDataContainer>
						<HeadsUpDataContainer label="O">{ciq.formatPrice(legendData.Open)}</HeadsUpDataContainer>
						<HeadsUpDataContainer label="L">{ciq.formatPrice(legendData.Low)}</HeadsUpDataContainer>
						<HeadsUpDataContainer label="H">{ciq.formatPrice(legendData.High)}</HeadsUpDataContainer>
						<HeadsUpDataContainer label="C">{ciq.formatPrice(legendData.Close)}</HeadsUpDataContainer>
						<HeadsUpDataContainer label="V">{CIQ.condenseInt(legendData.Volume)}</HeadsUpDataContainer>
					</HeadsUpOlhc>
					<HeadsUpExtra>
						<HeadsUpExtraWrapper extraColor={colors.accents.bad.base}>
							<span>OB </span>
							<span>{ciq.formatPrice(legendData.Percentile90)} / {ciq.formatPrice(legendData.Tftf90_open)}</span>
						</HeadsUpExtraWrapper>
						<HeadsUpExtraWrapper extraColor={colors.accents.good.base}>
							<span>OS </span>
							<span>{ciq.formatPrice(legendData.Percentile10)} / {ciq.formatPrice(legendData.Tftf10_open)}</span>
						</HeadsUpExtraWrapper>
						<HeadsUpExtraWrapper extraColor={colors.accents.bad.base}>
							<span>VIX </span>
							<span>{ciq.formatPrice(legendData.Vix)}</span>
						</HeadsUpExtraWrapper>
						<HeadsUpExtraWrapper extraColor={colors.accents.good.base}>
							<span>RVOL </span>
							<span>{ciq.formatPrice(legendData.Rvol)}</span>
						</HeadsUpExtraWrapper>
						{/* <HeadsUpExtraWrapper extraColor={colors.accents.soft.base}>
							<span>LAWR </span>
							<span>{ciq.formatPrice(legendData.LAWR)}</span>
						</HeadsUpExtraWrapper> */}
					</HeadsUpExtra>
				</HeadsUpDisplay>
			</LegendContainer>
		</LegendWrapper>
		// </cq-hu-static>
	);
};

const LegendWrapper = styled.div`
	background-color: ${({ theme }) => theme.core.alternateChartBackground};
	margin-left: 20px;
	margin-right: 20px;
	display: block;
	border-radius: 3px 3px 0px 0px;
	padding-bottom: 5px;
`

const LegendContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	justify-content: left;
	align-items: center;
	grid-gap: 3em;
`

const HeadsUpDisplay = styled.div`
	display: grid;
`

const HeadsUpOlhc = styled.div`
	grid-gap: 1.5em;
	display: grid;
	grid-template: auto / repeat(6, auto);
	justify-content: left;
  @media screen and (max-width: 1080px) {
		grid-gap: 0.5em;
		grid-template: repeat(3, auto) / repeat(3, auto);
	}
`

const HeadsUpExtra = styled.div`
	grid-gap: 1.5em;
	display: grid;
	grid-template-columns: repeat(5, auto);
	justify-content: left;
  @media screen and (max-width: 1080px) {
		grid-gap: 0.5em;
		grid-template: repeat(2, auto) / repeat(3, auto);
	}
`

const HeadsUpDataContainer = styled.div<{ label: string}>`
	&::before {
		opacity: 0.6;
		margin-right: 0.5em;
		color: ${({ theme }) => theme.core.textColor};
		content: '${({ label }) => label}';
	}
	color: ${colors.accents.aware.base};
`

const HeadsUpExtraWrapper = styled.div<{ extraColor: string}>`
	&::before {
		content: '';
		display: inline-block;
		width: 9px;
		height: 9px;
		border-radius: 4.5px;
		background-color: ${({ extraColor }) => extraColor};
		margin-right: 5px;
	}

	> :first-child {
		opacity: 0.6;
		margin-right: 0.5em;
	}
	> :last-child {
		color: ${({ extraColor }) => extraColor};
	}
`
